import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';

import { useAuth } from '@/api';
import { useWelcomeBannerDetails } from '@/api/digital-gold/gift-gold/welcomeBanner';
import { useFeatureFlags } from '@/api/feature-flags';
import closeIcon from '@/assets/icons/CrossWhite.svg';
import GiftGoldBannerGif from '@/assets/images/GiftGoldBanner.gif';
import routes from '@/routes/routes.json';

const BannerStates = {
  before24Hours: 'WELCOME_STATE',
  after24Hours: 'ACCEPTANCE_STATE',
};

export const GiftGoldWelcomeBanner = (props: { showBanner: boolean }) => {
  const { userDetails } = useAuth();
  const router = useRouter();
  const { featureFlags, isFlagsFetched } = useFeatureFlags();
  const { showBanner } = props;

  const giftGoldBannerPopupRef = useRef<HTMLButtonElement>(null);
  const giftGoldBannerCloseRef = useRef<HTMLButtonElement>(null);
  const { data: welcomeBannerDetails } = useWelcomeBannerDetails(
    userDetails?.id
  );

  let {
    error: showGiftGoldBanner,
    // eslint-disable-next-line prefer-const
    expectedHoursToCredit,
    // eslint-disable-next-line prefer-const
    bannerState: giftGoldBannerState,
  } = welcomeBannerDetails?.data?.data || {
    error: true,
    expectedHoursToCredit: 0,
    bannerState: null,
  };

  useEffect(() => {
    // If error is false we need to show Gift-Gold-Banner-Popup
    if (showGiftGoldBanner !== undefined && showGiftGoldBanner === false) {
      giftGoldBannerPopupRef.current?.click();
    } else {
      giftGoldBannerCloseRef.current?.click();
    }
  }, [welcomeBannerDetails]);

  const closeBannerModal = () => {
    showGiftGoldBanner = true;
    giftGoldBannerCloseRef.current?.click();
    router.push(`${routes.accountSettings}#orders?type=eSwarnaDigitalGold`);
  };

  // TODO : If present is specified routes & gift gold feature enabled & isflagsfetched
  if (showBanner && !featureFlags.dg_gift_gold && isFlagsFetched) {
    return null;
  }

  return (
    <>
      <button
        data-toggle="modal"
        data-target="#giftGoldBannerPopup"
        ref={giftGoldBannerPopupRef}
        // style={{ display: 'none' }}
        className="d-none"
      ></button>

      <div
        className={`modal loanDetails__modal addressDetail__modal fade `}
        id="giftGoldBannerPopup"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="giftGoldBannerPopupLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content gift-gold-banner-container">
            <div className="modal__title">
              <button
                data-dismiss="modal"
                className="gift-gold-close-icon"
                ref={giftGoldBannerCloseRef}
              >
                <Image
                  style={{ color: undefined }}
                  src={closeIcon}
                  alt="close icon"
                />
              </button>
            </div>
            <div className="interestDetail topup">
              <div className="gift-gold-banner-info-container">
                <Image
                  style={{ color: undefined }}
                  src={GiftGoldBannerGif}
                  alt="GiftGoldBanner"
                />
                <p className="gift-gold-heading">
                  {giftGoldBannerState === BannerStates.after24Hours
                    ? 'You have got a gift'
                    : 'Your Gift Is On The Way'}
                </p>
                <p className="gift-gold-info">
                  {
                    giftGoldBannerState === BannerStates.after24Hours
                      ? 'You have received a gift, please visit the My Orders section to view'
                      : `Check your eSwarna Digital Gold balance in ${expectedHoursToCredit} hours`
                    // TODO : Above written expectedHoursToCredit should be rechecked once we get proper response
                  }
                </p>
                {giftGoldBannerState === BannerStates.after24Hours && (
                  <>
                    <button
                      type="button"
                      onClick={() => closeBannerModal()}
                      className="gift-gold-view-gift-cta"
                    >
                      View Your Gift
                    </button>
                    <div className="gift-gold-note-container">
                      <div className="gift-gold-note-prefix"></div>
                      <p className="gift-gold-note-info">
                        <span className="gift-gold-note-heading">Note: </span>
                        Gifted gold can only be sold after 24 hours of
                        successfully receiving.
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
